import eCoachVMSApi from '../Api';

export const getServiceDefectData = async () => {
    try {
        const res = await eCoachVMSApi().baseURL.get('/getServiceDefectData');
        return res?.data;
    } catch (e) {
        return Promise.reject(e).response?.data;
    }
};
